module.exports = __webpack_public_path__ + "static/media/school.e248d696.svg";